module.exports = __webpack_public_path__ + "img/SER-i-1-I.801138ff.png";